<div class="card lead-contato">
    <!-- Table -->
    <ng-template [ngIf]="!isFormOpen">
        <div class="card-header card-header-table" *ngIf="showTableTitle">
            <h6 class="card-title">
                <i class="fas fa-phone"></i> Contatos
            </h6> 
        </div>        
        <div class="card-body card-body-table" [ngStyle]="{'max-height': tableMaxHeight}">
            <sgt-lead-contato-table
                #table
                [entities]="entities"
                (edit)="edit($event)"
                (delete)="delete($event)">
            </sgt-lead-contato-table>
        </div>
        <div class="card-footer card-footer-table">
            <sgt-pessoa-contato-dropdown-insert
                [dropup]="entities?.length > 8"
                (insert)="insert($event)">
            </sgt-pessoa-contato-dropdown-insert>
            
            <span class="quantidade-contatos">
                {{entities?.length}} contato(s)
            </span>
        </div>           
    </ng-template>

    <!-- Form -->
    <ng-template [ngIf]="isFormOpen">
        <div class="card-header card-header-form">
            <h6 class="card-title" *ngIf="!isFormEdit">
                Novo Contato {{form.entity?.tipo | pessoaContatoTipo}}
            </h6>
            <h6 class="card-title" *ngIf="isFormEdit">
                Editando Contato {{form.entity?.tipo | pessoaContatoTipo}}
            </h6>            
        </div>
        <div class="card-body card-body-form">
            <sgt-lead-contato-form
                #form
                [isMini]="isMini">
            </sgt-lead-contato-form>
        </div>        
        <div class="card-footer card-footer-form">
            <button type="button" class="btn btn-link btn-link-success" id="btnSaveContato" (click)="save()">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
            <button type="button" class="btn btn-link btn-link-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>        
    </ng-template>    
</div>
